import {Component, EventEmitter, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import { AlertService, IAlertType, InvoicesStoreService } from "../../../../_shared/services";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import { ClrCommonFormsModule, ClrDatepickerModule, ClrIconModule, ClrInputModule } from "@clr/angular";
import { DatePipe } from "@angular/common";
import moment from "moment/moment";
import { ClarityIcons, floppyIcon } from "@cds/core/icon";

@Component({
  selector: 'app-invoice-paid',
  standalone: true,
  imports: [
    ClrCommonFormsModule,
    ReactiveFormsModule,
    ClrInputModule,
    ClrDatepickerModule,
    DatePipe,
    ClrIconModule
  ],
  templateUrl: './invoice-paid.component.html',
  styleUrl: './invoice-paid.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de'}]
})
export class InvoicePaidComponent implements OnInit {
  paidForm: FormGroup = new FormGroup({
    amountPaid: new FormControl(),
    paidDate: new FormControl()
  });


  @Input() paidDate: string = '';
  @Input() praefix: string = '';
  @Input() invoiceId: string = '';
  @Input() saldo: number = 0;
  @Input() brutto: number = 0;
  @Output() updatedPaid = new EventEmitter();

  constructor(
    private invss: InvoicesStoreService,
    private alertDispatcher: AlertService,
    private fb: FormBuilder
  ) {
    ClarityIcons.addIcons(floppyIcon)
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm() {
    // RMS liefert das Datum als ISO oder als Leerstring. moment('') ist
    // ungueltig und lieferte frueher den String "Invalid date" ins Formular --
    // den das Backend mit 400 ablehnt, sodass auch der Betrag nicht ankam.
    const vorhanden = moment(this.paidDate, moment.ISO_8601, true);
    this.paidForm = this.fb.group({
      amountPaid: this.saldo,
      paidDate: [ (vorhanden.isValid() ? vorhanden : moment()).format('DD.MM.YYYY') ],
    });
  }

  /** Der Clarity-Datepicker liefert je nach Locale MM/DD/YYYY oder ein Date.
   *  Das Backend akzeptiert nur TT.MM.JJJJ oder JJJJ-MM-TT. */
  private normalizeDate(value: any): string {
    if (!value) return '';
    if (value instanceof Date) {
      const d = value as Date;
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }
    const raw = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(raw)) return raw;
    const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (us) return `${us[3]}-${us[1].padStart(2, '0')}-${us[2].padStart(2, '0')}`;
    return raw;
  }

  updatedSaldo() {
    const werte = { ...this.paidForm.value, paidDate: this.normalizeDate(this.paidForm.value.paidDate) };
    if (!werte.paidDate) {
      this.alertDispatcher.show({
        message: 'Bitte ein Datum des Zahlungseingangs angeben.',
        clrAlertType: IAlertType.WARNING
      }, 5000);
      return;
    }
    this.invss.updatePaid(this.praefix + '.' + this.invoiceId, werte)
      .subscribe({
        next: () => {
            this.updatedPaid.emit(true);
        },
        complete: () => {
          this.alertDispatcher.show({
            message: 'Zahlungseingang wurde aktualisiert.',
            clrAlertType: IAlertType.SUCCESS
          }, 5000);
        },
        error: () => {
          this.alertDispatcher.show({
            message: 'Zahlungseingang kontte nicht aktualisiert werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
      });
  }
}
